import { planHasCapability, getPlanById } from '../config/plans'

/** User-facing copy when a plan blocks a feature. */
export const planUpgradeMessage = (capability, planId = 'starter') => {
  const plan = getPlanById(planId)
  const labels = {
    teams: 'Teams',
    tags: 'Tags',
    storageRequests: 'Storage increase requests',
    orgAuditLogs: 'Organization audit logs',
    advancedSearch: 'Advanced search',
    watermark: 'Watermark downloads',
    ocr: 'OCR search',
    webhooks: 'Webhooks',
    retention: 'Retention policies',
    legalHold: 'Legal hold',
    quarantine: 'Quarantine',
    sessionsAdmin: 'Session administration'
  }

  const feature = labels[capability] || capability
  const needed =
    capability === 'webhooks' ||
    capability === 'retention' ||
    capability === 'legalHold' ||
    capability === 'quarantine' ||
    capability === 'sessionsAdmin' ||
    capability === 'ipAllowlists'
      ? 'Enterprise'
      : 'Business or Enterprise'

  return `${feature} is not included in the ${plan?.name || 'current'} plan. Upgrade to ${needed} to use this feature.`
}

export const canUsePlanFeature = (capabilities, capability) => {
  if (!capability) {
    return true
  }

  if (capabilities && typeof capabilities === 'object') {
    return Boolean(capabilities[capability])
  }

  return planHasCapability('starter', capability)
}

export default planUpgradeMessage
